import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import styles from "./InputEditButton.module.scss";

export type InputEditButtonProps = {
  label?: string;
  onClick: () => void;
  dataTestId?: string;
};

/**
 * Textual action rendered inside the `elemAfter` slot of `TextInput`,
 * used to unlock a read-only field or to trigger a field related action.
 */
export const InputEditButton: FC<InputEditButtonProps> = ({ label, onClick, dataTestId }) => {
  const { __ } = useTranslations();

  return (
    <button type="button" onClick={onClick} className={styles.editButton} data-testid={dataTestId}>
      {label || __("text_input.default_edit_label")}
    </button>
  );
};
